var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardicon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319785"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2330",
    cx: 26.4671,
    cy: 27.0257,
    r: 25.7267,
    fill: "MainStyle.$theme-btn",
    fillOpacity: 0.12,
    stroke: "MainStyle.$theme-btn",
    strokeWidth: 0.887127
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427319784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.516 20.161L15.0555 27.0638C14.07 27.8679 13.5769 28.2701 13.3167 28.7448C12.9698 29.3776 12.8872 30.1164 13.0861 30.7985C13.2354 31.3101 13.6287 31.7922 14.4153 32.7563C16.1675 31.3267 18.7213 31.5568 20.1198 33.271C21.5183 34.9851 21.2318 37.5338 19.4796 38.9634C20.2662 39.9275 20.6595 40.4096 21.1307 40.6585C21.759 40.9903 22.4991 41.0573 23.1887 40.8445C23.7059 40.6848 24.199 40.2827 25.1845 39.4786L33.645 32.5758M23.516 20.161L27.7463 16.7096C28.7318 15.9056 29.2245 15.5035 29.7417 15.3439C30.4313 15.1311 31.1718 15.1983 31.8002 15.5301C32.2714 15.779 32.6647 16.261 33.4513 17.2251C31.6991 18.6547 31.4122 21.2029 32.8108 22.917C34.2093 24.6312 36.7634 24.8619 38.5156 23.4323C39.3022 24.3964 39.6955 24.8784 39.8447 25.39C40.0437 26.0722 39.9606 26.8107 39.6137 27.4436C39.3535 27.9182 38.8608 28.3204 37.8753 29.1244L33.645 32.5758M23.516 20.161L33.645 32.5758",
    stroke: "MainStyle.$theme-btn",
    strokeWidth: 1.33069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon2);
export default __webpack_public_path__ + "static/media/dashboardicon2.429c03ae813817b1e7a755486cb16ad1.svg";
export { ForwardRef as ReactComponent };